<script>
    import { InputText, Select, TextArea, Row } from '../UI'
    import { confImp as confImp_ } from '$lib/conf'
    import { validarCuit } from '$lib/utils'
    import dictionaries from '../../stores/dictionaries'
    import DocumentationField from './DocumentationField.svelte'
    export let data = {}
    export let restricted = false
    export let inputs = null
    export let editable = true
    export let showDoc = true
    export let valid = false
    export let dynamic = true
    export let providerSiniestros = false

    $: allowedInputs = inputs instanceof Array ? inputs : []

    $: showAll = !(allowedInputs.length > 0)
    let confImp = confImp_
    if (
        providerSiniestros &&
        confImp.general.findIndex((x) => x.name === 'docu_f931_ii') === -1
    ) {
        confImp.general.push({
            // Forfumlario obligatorio para proveedores de siniestros
            title: 'Adjuntar Formulario F931 o Declaración de No empleados',
            label: 'Formulario F931 o Declaración de No empleados',
            type: '2',
            name: 'docu_f931_ii',
            inputs: ['files*'],
            required: true,
        })
    }
    function allowInputs() {
        let args = Array.prototype.slice.call(arguments)
        return showAll || args.some((x) => allowedInputs.includes(x))
    }
    if (dynamic && data.tipo_doc_dp == '2' && data.no_doc_dp) {
        data.cuit_ii = data.no_doc_dp
    }
    let documentation = {}
    $: valid =
        Object.values(documentation).length > 0
            ? Object.values(documentation).every((x) => x === true)
            : true
    $: ({
        condicion_imp_iva_ii,
        condicion_imp_ganancias_ii,
        condicion_imp_ingresos_ii,
    } = data)
    if (dynamic && condicion_imp_ingresos_ii) {
        data.docu_iibb_ii = undefined
    }
    if (providerSiniestros === true) {
        data.tipo_proveedor_ii = '4'
        data.condicion_imp_ganancias_ii = '0'
    }
    $: console.log({ providerSiniestros })
</script>

{#if allowInputs('tipo_proveedor_ii', 'cuit_ii')}
    <Row>
        {#if allowInputs('tipo_proveedor_ii') && !providerSiniestros}
            <Select
                required
                disabled={!editable}
                bind:value={data.tipo_proveedor_ii}
                name="tipo_proveedor_ii"
                label="Tipo Proveedor"
                options={$dictionaries?.tipo_proveedor?.filter(o => o.value !== '4') || []}
                placeholder="Seleccione una opción."
            />
        {/if}
        {#if allowInputs('cuit_ii')}
            <InputText
                required
                disabled={!editable || restricted}
                errorMsg="Ingrese un CUIT válido."
                info="El CUIT debe contener 11 dígitos numéricos."
                validation={(n) => typeof n === 'string' && validarCuit(n)}
                name="cuit_ii"
                label="CUIT N°"
                bind:value={data.cuit_ii}
            />
        {/if}
    </Row>
{/if}
{#if allowInputs('condicion_imp_iva_ii')}
    <Row>
        <Select
            required
            disabled={!editable}
            name="condicion_imp_iva_ii"
            label="Condición Frente al I.V.A"
            options={$dictionaries.condicion_iva}
            placeholder="Seleccione una opción."
            bind:value={data.condicion_imp_iva_ii}
        />
    </Row>
    {#key condicion_imp_iva_ii}
        {#if condicion_imp_iva_ii in confImp.condicion_iva && showDoc}
            {@const docConf = confImp.condicion_iva[condicion_imp_iva_ii]}
            <DocumentationField
                bind:valid={documentation.condicion_iva}
                value={data.docu_iva_ii}
                name="docu_iva_ii"
                {...docConf}
                on:delete={(_) => {
                    data.docu_iva_ii = docConf.multi ? [] : {}
                    documentation.condicion_iva = true
                }}
            />
        {/if}
    {/key}
{/if}
{#if allowInputs('condicion_imp_ganancias_ii') && !providerSiniestros}
    <Row>
        <Select
            required
            name="condicion_imp_ganancias_ii"
            label="Condición Frente al Impuesto de Ganancias"
            options={$dictionaries.condicion_ganancias}
            placeholder="Seleccione una opción."
            disabled={!editable}
            bind:value={data.condicion_imp_ganancias_ii}
        />
    </Row>
    {#key condicion_imp_ganancias_ii}
        {#if condicion_imp_ganancias_ii in confImp.condicion_ganancias && showDoc}
            {@const docConf =
                confImp.condicion_ganancias[condicion_imp_ganancias_ii]}
            <DocumentationField
                name="docu_ganancias_ii"
                bind:valid={documentation.condicion_ganancias}
                value={data.docu_ganancias_ii}
                {...docConf}
                on:delete={(_) => {
                    data.docu_ganancias_ii = docConf.multi ? [] : {}
                    documentation.condicion_ganancias = true
                }}
            />
        {/if}
    {/key}
{/if}
{#if allowInputs('condicion_imp_ingresos_ii')}
    <Row>
        <Select
            required
            disabled={!editable}
            name="condicion_imp_ingresos_ii"
            label="Condición Frente al Impuesto a los Ingresos Brutos"
            options={$dictionaries.posicion_ingresos}
            placeholder="Seleccione una opción."
            bind:value={data.condicion_imp_ingresos_ii}
        />
    </Row>
    {#key condicion_imp_ingresos_ii}
        {#if condicion_imp_ingresos_ii in confImp.condicion_iibb && showDoc}
            {@const docConf = confImp.condicion_iibb[condicion_imp_ingresos_ii]}
            <DocumentationField
                name="docu_iibb_ii"
                bind:valid={documentation.condicion_iibb}
                value={data.docu_iibb_ii}
                {...docConf}
                on:delete={(_) => {
                    data.docu_iibb_ii = docConf.multi ? [] : {}
                    documentation.condicion_iibb = true
                }}
            />
        {/if}
    {/key}
{/if}
{#if allowInputs('no_ingresos_brutos_ii')}
    <Row>
        <InputText
            required
            disabled={!editable}
            errorMsg="Ingrese un N° Inscripción Ingresos Brutos válido."
            info="El Nro. Inscripción Ingresos Brutos debe contener solo números."
            maxLength={14}
            validation={(n) =>
                typeof n === 'string' && n.match(/^[0-9]{8,14}$/)}
            bind:value={data.no_ingresos_brutos_ii}
            name="no_ingresos_brutos_ii"
            label="N° Inscripción Ingresos Brutos"
        />
    </Row>
{/if}
{#if allowInputs('empleador_ii')}
    <Row>
        <Select
            bind:value={data.empleador_ii}
            name="empleador_ii"
            label="SUSS – Empleador"
            options={$dictionaries.empleador}
            required={data.condicion_imp_iva_ii === '1'}
            disabled={!(editable && data.condicion_imp_iva_ii === '1')}
            placeholder="Seleccione una opción."
        />
    </Row>
{/if}
{#if showDoc}
    {#each confImp.general as conf}
        <DocumentationField
            {...conf}
            bind:valid={documentation[conf.name]}
            bind:value={data[conf.name]}
        />
        <br />
    {/each}
    {#each confImp.otros as conf, i (i)}
        <DocumentationField
            {...conf}
            bind:valid={documentation[conf.name]}
            bind:value={data[conf.name]}
            on:delete={(_) => {
                delete data[conf.name][i]
                delete documentation[conf.name]
            }}
        />
        <br />
    {/each}
{/if}
<TextArea
    bind:value={data.observaciones_ii}
    name="observaciones_ii"
    disabled={!editable}
    label="Observaciones"
/>
